import Service from '../Service'
import { formataDataBD, formatDateToTimestamps } from '@/utils/utils'

export default class OrderService extends Service {
  constructor() {
    super('')
    this.resource = 'orders'
  }

  translateToFirebird(payload) {
    const parcelamentos = payload.newParcelamentos
      ? payload.newParcelamentos.map((current) => ({
          SEQ: current.index,
          DATA: formataDataBD(current.data),
          VENCIMENTO:
            current.vencimento == 'A VISTA'
              ? formataDataBD(current.data)
              : formataDataBD(current.vencimento),
          CONDICAOPGTO: { CODIGO: current.codigoCondicao },
          CONDICAO: current.condicao,
          CONTA: current.conta ? { CODIGO: current.conta.CODIGO } : null,
          CT: current.ct,
          VALOR: current.valor,
          ACRESCIMOFINANCEIRO: current.valorAcrescimoFinanceiro,
          INFORMOUVALOR: current.informouValor,
        }))
      : []

    let firebirdObject = {
      EMPRESA: payload.empresa ? { CODIGO: payload.empresa.CODIGO } : undefined,
      VENDEDOR: {
        CODIGO: payload.vendedor ? payload.vendedor.CODIGO : '',
      },
      DEPARTAMENTO: payload.departamento.CODIGO
        ? { CODIGO: payload.departamento.CODIGO }
        : undefined,
      DATA: formatDateToTimestamps(payload.data),
      PREVISAOENTREGA: formatDateToTimestamps(payload.previsaoEntrega),
      TIPOPREVISAOENTREGA: payload.tipoPrevisaoEntrega
        ? payload.tipoPrevisaoEntrega
        : 'Entrega',
      LIBERADO: payload.liberado,
      FILIAL: payload.filial,
      MOEDA: payload.moeda,
      TIPOPRECO:
        payload.tipoPreco === 'PRECOVAREJO'
          ? 'Varejo'
          : payload.tipoPreco === 'PRECOATACADO'
          ? 'Atacado'
          : payload.tipoPreco === 'PRECOESPECIAL'
          ? 'Especial'
          : payload.tipoPreco === 'PRECOESPECIAL2'
          ? 'Especial2'
          : payload.tipoPreco === 'PRECOESPECIAL3'
          ? 'Especial3'
          : 'Varejo',
      PARCELAMENTOS: parcelamentos,
      VALORACRESCIMOFINANCEIRO: payload.valorAcrescimoFinanceiro,
    }
    if (payload.sequencial) firebirdObject.SEQUENCIAL = payload.sequencial
    if (payload.condicaoPgto) {
      firebirdObject.CONDICAOPGTO = {
        CODIGO: payload.condicaoPgto.CODIGO,
        CT: payload.ct,
      }
    }
    if (payload.obra) {
      firebirdObject.OBRA = payload.obra
      if (payload.fase) {
        firebirdObject.FASE = payload.fase
      }
    }
    return firebirdObject
  }

  translateFromFirebird(payload) {
    let orderObject = {
      ano: payload.ANO,
      arredondamentoDesconto: payload.ARREDONDAMENTODESCONTO,
      codigoUsuario: payload.CODIGOUSUARIO,
      controleEntrega: payload.CONTROLEENTREGA,
      data: payload.DATA,
      dataEmissao: payload.DATAEMISSAO,
      dataInclusaoAlteracao: payload.DATAINCLUSAOALTERACAO,
      departamento: { ...payload.departamento },
      razaoSocial: payload.NOME_EMPRESA,
      empresa: {
        ...payload.empresa,
        CODIGO: payload.empresa ? parseInt(payload.empresa.CODIGO) : 0, // combobox precisa que seja inteiro
      },
      filial: payload.FILIAL,
      geradoPelaRotina: payload.GERADOPELAROTINA,
      hora: payload.HORA,
      liberado: payload.LIBERADO,
      moeda: parseInt(payload.MOEDA ?? 0, 10),
      numero: payload.NUMERO,
      origem: payload.ORIGEM,
      pagarComissaoEm: payload.PAGARCOMISSAOEM,
      percentualDesconto: payload.PERCENTUALDESCONTO,
      preLiberado: payload.PRELIBERADO,
      previsaoEntrega: payload.PREVISAOENTREGA,
      qntEntregueTotal: payload.QNTENTREGUETOTAL,
      sequencial: payload.SEQUENCIAL,
      serie: payload.SERIE,
      tipo: payload.TIPO,
      tipoPreco:
        payload.TIPOPRECO == 'Varejo'
          ? 'PRECOVAREJO'
          : payload.TIPOPRECO == 'Atacado'
          ? 'PRECOATACADO'
          : payload.TIPOPRECO == 'Especial'
          ? 'PRECOESPECIAL'
          : payload.TIPOPRECO == 'Especial2'
          ? 'PRECOESPECIAL2'
          : payload.TIPOPRECO == 'Especial3'
          ? 'PRECOESPECIAL3'
          : 'PRECOVAREJO',
      tipoPrevisaoEntrega: payload.TIPOPREVISAOENTREGA,
      totalEmAberto: payload.TOTALEMABERTO,
      usuario: payload.USUARIO,
      valorTerceiros: payload.VALORTERCEIROS,
      vendedor: { ...payload.vendedor },
      condicaoPgto: payload.tipo_venda ?? undefined,
      ct: payload.CT,
      valor: payload.VALOR,
      valorAcrescimoFinanceiro: payload.VALORACRESCIMOFINANCEIRO,
      obra: payload.OBRA,
      fase: payload.FASE,
    }

    return orderObject
  }

  createRequestUrl(payload, type) {
    let requestUrl =
      type === 'unique' ? `${this.resource}/` : `${this.resource}?`

    if (payload) payload = this.encodeQueryValues(payload)

    if (payload && payload.numero)
      requestUrl += `N-${payload.numero}-${payload.serie}`
    if (payload && payload.sequencial) requestUrl += `S-${payload.sequencial}`
    if (payload && payload.razaoSocial)
      requestUrl += this.hasParameter(requestUrl)
        ? `&RAZAOSOCIAL=${payload.razaoSocial}`
        : `RAZAOSOCIAL=${payload.razaoSocial}`
    if (payload && payload.codigoEmpresa)
      requestUrl += this.hasParameter(requestUrl)
        ? `&EMPRESACODIGO=${payload.codigoEmpresa}`
        : `EMPRESACODIGO=${payload.codigoEmpresa}`

    if (payload && payload.liberado)
      requestUrl += this.hasParameter(requestUrl)
        ? `&SELECIONA=${payload.liberado}`
        : `SELECIONA=${payload.liberado}`

    // trazer apenas os ultimos orcamentos e não paginar
    if (payload && payload.ultimosOrcamentos)
      requestUrl += this.hasParameter(requestUrl)
        ? `&LAST=${payload.ultimosOrcamentos}`
        : `LAST=${payload.ultimosOrcamentos}`

    // if(payload && payload.numero)
    // requestUrl += this.hasParameter(requestUrl) ? `&NUMERO=${payload.numero}` : `NUMERO=${payload.numero}`;
    // if(payload && payload.sequencial)
    // requestUrl += this.hasParameter(requestUrl) ? `&SEQUENCIAL=${payload.sequencial}` : `SEQUENCIAL=${payload.sequencial}`

    return requestUrl
  }

  async insertOrder(payload) {
    let data = this.translateToFirebird(payload)
    return await this.insert(data)
  }

  async loadOrder(payload) {
    let requestUrl = this.createRequestUrl(payload, 'unique')
    return await this.getAPI(requestUrl)
  }

  async updateOrder(payload) {
    let data = this.translateToFirebird(payload)
    return await this.update(data, data.SEQUENCIAL)
  }

  async getOrders(payload) {
    let requestUrl = this.createRequestUrl(payload, 'multiple')
    let ordersListJS = []
    let ordersListFB = await this.getAPI(requestUrl)

    if (ordersListFB.data) ordersListFB = ordersListFB.data

    await ordersListFB.forEach((element) => {
      ordersListJS.push(this.translateFromFirebird(element))
    })
    return ordersListJS
  }
}
